// import lifeEventCategory from './lifeEventCategory';
// import lifeEventTheme from './lifeEventTheme';
import lifeEvent from './lifeEvent';
import encouragement from './encouragement';

export default {
  // lifeEventCategory,
  // lifeEventTheme,
  lifeEvent,
  encouragement,
};



// WEBPACK FOOTER //
// ./src/schemas/contentEditor/index.js